var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrayarrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 32H48a16 16 0 00-16 16v160a16 16 0 0016 16h160a16 16 0 0016-16V48a16 16 0 00-16-16zM90.34 114.34a8 8 0 0111.32 0L120 132.69V72a8 8 0 0116 0v60.69l18.34-18.35a8 8 0 0111.32 11.32l-32 32a8 8 0 01-11.32 0l-32-32a8 8 0 010-11.32zM208 208H48v-40h28.69L96 187.32a15.89 15.89 0 0011.31 4.68h41.38a15.86 15.86 0 0011.31-4.69L179.31 168H208v40z"
  })));
}

export default SvgTrayarrowdown;